import { ResultadoAnaliseOS__Item } from "../../../../../../../../../services/AgriculturaPrecisao/bookResumido/GET"
import { ItensMapaFertilidadeTypes } from "../../../../../../../../../services/Laboratorio/osResultado"

/**adciona `|` para separar o nome da profundidade */
export function replaceCalcario(nome_calcario: string): string {
    switch (nome_calcario) {
        case 'Calcário 00-20':
            return 'Calcário | 00-20'

        case 'Calcário | 00-20':
            return 'Calcário 00-20'

        case 'Calcário 00-30':
            return 'Calcário | 00-30'

        case 'Calcário 00-40':
            return 'Calcário | 00-40'

        default:
            return nome_calcario
    }
};

export function replceCalcarioDescription(nome_calcario: string): string {
    switch (nome_calcario) {
        case 'Calcário 00-20':
            return 'Calcário | 00-20'
        case 'Calcário 00-30':
            return 'Calcário | 00-30'
        case 'Calcário 00-40':
            return 'Calcário | 00-40'
        case 'Calcário 20-40':
            return 'Calcário | 20-40'
        default:
            return nome_calcario;
    }
}

/**adicona `cm` ao final caso a profundidadea não seja `[micro, indicadores, prescrições]` */
export function nomeProfundidade(nome_profundidade: string): string {
    if (nome_profundidade !== 'micro' && nome_profundidade !== 'indicadores' && nome_profundidade !== 'prescricoes') {
        return `${nome_profundidade} cm`;
    }

    return nome_profundidade;
}

export function listaFertilidadesComCalcario(lista_fertility: ItensMapaFertilidadeTypes[]) {

    let dados_receber = lista_fertility ?? [];

    for (const item_elemento of dados_receber) {
        item_elemento.elemento_descricao = item_elemento.cod_elemento == 30
            ? (`Calcário | ${item_elemento.profundidade}`).slice(0, 16)
            : `${item_elemento.elemento_descricao}`;
    }

    return dados_receber;
}

export function obterInfoDoElemento(lista_de_elementos: any, nome_elemento: string) {

    return lista_de_elementos[replaceCalcario(nome_elemento)]?.[0] ?? lista_de_elementos[nome_elemento]?.[0];
}

type dadosArgs = {
    lista_dados_os: ResultadoAnaliseOS__Item[], 
    cod_elemento: number, 
    profundidade: string,
    cods_elementos_selecionados: number[],
    talhoes_selecionados: { cod_talhao: number, nome_talhao: string, cod_pedido: number, talhao_area: number, coordenadas: { latitude: number, longitude: number }[] }[],
    talhoes_filtrados: number[],
    is_indicadores: boolean,
    is_prescricoes: boolean,
    profundidade_calcario: string
}
export function dadosElemento(args: dadosArgs): {minimo:string,media:string,maximo:string} {
    let { lista_dados_os, cod_elemento, profundidade, cods_elementos_selecionados, talhoes_filtrados, 
        talhoes_selecionados, is_indicadores, is_prescricoes, profundidade_calcario } = args;

    let filtrar_talhoes = talhoes_filtrados.length === 0 ? talhoes_selecionados : talhoes_selecionados.filter(item=> talhoes_filtrados.includes(item.cod_pedido))

    //@ts-ignore
    let list_cods_pedido = new Set(((filtrar_talhoes??[]).map(i=> i.cod_pedido)).flat());

    let apenas_elementos_selecionados = lista_dados_os.filter(item => cods_elementos_selecionados.includes(item.cod_elemento));
    let apenas_pedidos_dos_talhoes = apenas_elementos_selecionados.filter(item=> list_cods_pedido.has(item.cod_pedido));

    function pedidosElementos() {
        if (is_indicadores) {
            return apenas_pedidos_dos_talhoes.filter(item=> item.cod_elemento === cod_elemento)
        }
        if (is_prescricoes) {
            if (cod_elemento===30) {
                return apenas_pedidos_dos_talhoes.filter(item=> item.cod_elemento === cod_elemento  && item.profundidade === profundidade_calcario)
            }
            return apenas_pedidos_dos_talhoes.filter(item=> item.cod_elemento === cod_elemento)
        }
        return apenas_pedidos_dos_talhoes.filter(item=> item.cod_elemento === cod_elemento && item.profundidade === profundidade)
    }

    let pedidos_do_elemento = pedidosElementos();

    return {
        minimo: (Math.min(...pedidos_do_elemento.map(item => Number(item.minimo)))).toFixed(3),
        media: ((pedidos_do_elemento.reduce((total, item) => total + Number(item.media), 0)) / pedidos_do_elemento.length).toFixed(3),
        maximo: (Math.max(...pedidos_do_elemento.map(item => Number(item.maximo)))).toFixed(3),
    }
}